
import {useEffect, useState } from 'react';

const SCROLL_BEHIND_CONTAINER = 102;

export const useFastScrolling = (scrollingElement: any): any => {
    const [isFastScrolling, setFastScrolling] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (scrollingElement) {
                const el = document.querySelector('.infinite-scroll-component__outerdiv');
                if (el) {
                    if (((el?.scrollHeight / window.scrollY) * 100) <= SCROLL_BEHIND_CONTAINER)
                    {
                        setFastScrolling(true);
                    }
                }
            }
        })
    }, [scrollingElement])

    return [isFastScrolling, setFastScrolling];
}

import {useEffect, useState } from 'react';

const SCROLL_BEHIND_CONTAINER = 102;

export const useFastScrolling = (scrollingElement: any): any => {
    const [isFastScrolling, setFastScrolling] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (scrollingElement) {
                const el = document.querySelector('.infinite-scroll-component__outerdiv');
                if (el) {
                    if (((el?.scrollHeight / window.scrollY) * 100) <= SCROLL_BEHIND_CONTAINER)
                    {
                        setFastScrolling(true);
                    }
                }
            }
        })
    }, [scrollingElement])

    return [isFastScrolling, setFastScrolling];
}
